// Constants
import { MaxDailyRecurrenceInterval, MaxMonthlyRecurrenceInterval, MaxWeeklyRecurrenceInterval, MaxYearlyRecurrenceInterval } from "@ms/uno-constants/lib/local/RecurrenceConstants";
import { DayOfWeek } from "@ms/uno-constants/lib/local/DateConstants";
// Utilities
import { ErrorUtilities } from "@ms/uno-errors/lib/local/utilities/ErrorUtilities";
// Enums
import { RecurrencePatternType } from "../../../../service/planner/enumerations/IPlannerEnumerations";
import { RecurrenceDropdownType } from "../RecurrenceDropdownType";
/**
 * Returns the repeat option represented by a stored recurrence pattern.
 */ export function getRecurrenceDropdownTypeFromPattern(pattern) {
    if (pattern === undefined) {
        return RecurrenceDropdownType.NotRepeat;
    }
    switch(pattern.patternType){
        case RecurrencePatternType.Daily:
            return RecurrenceDropdownType.Daily;
        case RecurrencePatternType.Weekly:
            {
                const daysOfWeek = pattern.daysOfWeek;
                return pattern.interval === 1 && daysOfWeek?.length === 5 && !daysOfWeek.includes(DayOfWeek.Saturday) && !daysOfWeek.includes(DayOfWeek.Sunday) ? RecurrenceDropdownType.Weekdays : RecurrenceDropdownType.Weekly;
            }
        case RecurrencePatternType.FixedDayOfMonth:
        case RecurrencePatternType.RelativeDayOfMonth:
            return RecurrenceDropdownType.Monthly;
        case RecurrencePatternType.FixedDayOfYear:
        case RecurrencePatternType.RelativeDayOfYear:
            return RecurrenceDropdownType.Yearly;
        default:
            return undefined;
    }
}
/**
 * Returns the interval limits for a given recurrence pattern
 */ export function getRecurrenceIntervalLimits(patternOrDropdownType) {
    switch(patternOrDropdownType){
        case RecurrencePatternType.Daily:
        case RecurrenceDropdownType.Daily:
            return MaxDailyRecurrenceInterval;
        case RecurrencePatternType.Weekly:
        case RecurrenceDropdownType.Weekly:
        case RecurrenceDropdownType.Weekdays:
            return MaxWeeklyRecurrenceInterval;
        case RecurrencePatternType.FixedDayOfMonth:
        case RecurrencePatternType.RelativeDayOfMonth:
        case RecurrenceDropdownType.Monthly:
            return MaxMonthlyRecurrenceInterval;
        case RecurrencePatternType.FixedDayOfYear:
        case RecurrencePatternType.RelativeDayOfYear:
        case RecurrenceDropdownType.Yearly:
            return MaxYearlyRecurrenceInterval;
        case RecurrenceDropdownType.NotRepeat:
        case RecurrenceDropdownType.Custom:
            return 0;
        default:
            ErrorUtilities.unreachableCase(patternOrDropdownType, ()=>{
            // Log function - no traceLogger available in this context
            });
            throw new Error(`Unsupported recurrence pattern/dropdown type ${patternOrDropdownType}`);
    }
}
